import React from 'react';
import { useModal } from './ModalContext';
import ApplyForm from "./ApplyForm";
import styles from "./styles.module.scss"

const Modal: React.FC = () => {
  const { isVisible, hideModal, inviteCode } = useModal();

  return (
    isVisible ?
        <div className={styles.regModal}>
          <div className={styles.hideBtn}>
            <svg  onClick={hideModal} xmlns="http://www.w3.org/2000/svg" fill="none" width="30.328" height="30.328"><path d="M27.5 30.328 0 2.828 2.828 0l27.5 27.5-2.828 2.828Z" fillRule="evenodd" fill="#15181D"/><path d="m2.828 30.328 27.5-27.5L27.5 0 0 27.5l2.828 2.828Z" fillRule="evenodd" fill="#15181D"/></svg>
          </div>
          <div className={styles.content}>
            <div>
              <div className={styles.left}>
                <h2>申请试用</h2>
                <p>免费试用并了解更多关于烯牛数据的产品和服务，请填写您的个人信息，我们会尽快回复
                  <br />
                  提交申请将会电话审核，虚假信息不予通过。如有问题可联系
                  <span>烯牛客服</span></p>
              </div>
              <div className={styles.right}>
                <ApplyForm onClose={hideModal} defaultInviteCode={inviteCode}/>
              </div>
            </div>
          </div>
      </div>
      :
      null
  )
}





export default Modal;
